import React, { useState } from "react";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import Spinner from "../../../Component/Spinner/Spinner";
import ConfirmationModal from "../../Shared/ConfirmationModal/ConfirmationModal";

const AllSeller = () => {
  const [deletingSeller, setDeletingSeller] = useState(null);
  const [makeAdmin, setMakeAdmin] = useState(null);

  const closeModal = () => {
    setDeletingSeller(null);
  };

  const closeAdminModal = () => {
    setMakeAdmin(null);
  }

  const {
    data: seller = [],
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["seller"],
    queryFn: async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/users?role=seller`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${localStorage.getItem('token')}`
        }
      });
      const data = res.json();
      return data;
    },
  });


  const handleDeleteSeller = (seller) => {
    fetch(`${process.env.REACT_APP_API_URL}/users/seller/${seller._id}`, {
      method: "DELETE",
      headers: {
        authorization: `bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.deletedCount > 0) refetch();
        toast.success(`User ${seller.name} deleted successfully`);
      });
  };

  const handleMakeAdmin = async (id) => {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/users/admin/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    const data = await res.json();
    if (data.success) {
      toast.success(data.message);
    } else {
      toast.error(data.error);
    }
    refetch();
  };

  if (isLoading) {
    return <Spinner />;
  }
  

  return (
    <div className="mx-10">
      <h1 className="text-2xl">all Seller</h1>
      <div className="overflow-x-auto w-full">
        <table className="w-full whitespace-no-wrap">
          {/* <!-- head --> */}
          <thead>
            <tr className="text-xs font-semibold tracking-wide text-left text-gray-700 uppercase border-b dark:border-gray-700 bg-gray-300 dark:text-gray-400 dark:bg-black">
              <th className="px-4 py-3">Image</th>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Join Date</th>
              <th className="px-4 py-3">Admin Action</th>
              <th className="px-4 py-3">Delete Action</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-900">
            {seller?.data?.map((sell) => (
              <tr key={sell._id}>
                <td className="px-4 py-3 ">
                  <div className="flex items-center space-x-3">
                    <div className="avatar">
                      <div className="mask mask-squircle w-12 h-12">
                        <img
                          src={sell.image}
                          alt={sell.name}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3 ">
                  <div>
                    <div className="font-bold">{sell.name}</div>
                  </div>
                </td>
                <td className="px-4 py-3 ">{sell.email}</td>
                <td className="px-4 py-3 text-xs">
                  {
                    sell?.isVerified === true ? (
                      <span className="px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full dark:bg-green-700 dark:text-green-100">Verified</span>
                    ) : (
                        <span className="px-2 py-1 font-semibold leading-tight text-orange-700 bg-orange-100 rounded-full dark:text-white dark:bg-orange-600">Not verified</span>
                    )
                  }
                </td>
                <td className="px-4 py-3 ">{sell.joinDate}</td>
                <td className="px-4 py-3 ">
                  <label
                    htmlFor="confirmation-modal"
                  onClick={() => setMakeAdmin(sell)}
                  title={
                    sell?.role === "admin"? "You are already an admin" : "Make Admin"
                  }
                  className={
                    sell?.role === "admin"
                    ? "btn btn-xs btn-danger"
                      : "btn btn-xs btn-warning"
                  }
                  disabled={
                    sell?.role === "admin" ? true : false
                  }
                  >
                    Make Admin
                  </label>
                </td>
                <th>
                  <label
                    onClick={() => setDeletingSeller(sell)}
                    htmlFor="confirmation-modal"
                    className="btn btn-error btn-xs">
                    Delete
                  </label>
                </th>
              </tr>
            ))}
          </tbody>
        </table>
        {makeAdmin && (
          <ConfirmationModal
            title={`Are you sure you want to make this user an admin?`}
            message={`If you want to make admin ${makeAdmin.name}. It cannot be undone.`}
            successAction={handleMakeAdmin}
            successButtonName="Admin"
            modalData={makeAdmin}
            closeModal={closeAdminModal}></ConfirmationModal>
        )}
      </div>
      {deletingSeller && (
        <ConfirmationModal
          title={`Are you sure you want to delete?`}
          message={`If you delete ${deletingSeller.name}. It cannot be undone.`}
          successAction={handleDeleteSeller}
          successButtonName="Delete"
          modalData={deletingSeller}
          closeModal={closeModal}></ConfirmationModal>
      )}
    </div>
  );
};

export default AllSeller;
